export const MODAL_LAYER_Z_INDEX = {
  cabinet: 9998,
  feedbackBackdrop: 9999,
  feedbackContent: 10000,
  feedbackModal: 10001,
} as const;
